import Dashboard from '@/views/dashboard.vue'
import LoginPage from '@/pages/user/account/login.vue'
import Logout from '@/pages/user/account/logout'
import My from '@/views/My.vue'
// import PersonInfoPage from '@/pages/event/person-info.vue'
import Live from '@/pages/event/live.vue'
import LiveCustom from '@/pages/event/live-custom.vue'
import UserRoutes from '@/routes/user'
import OnlineRoutes from '@/routes/online'
import ProductRoutes from '@/routes/product'
import EventRoutes from './routes/event'
import PaymentRoutes from './routes/payment'
import MailingRoutes from './routes/mailing'
import order from '@/routes/order'
import InstructionRoutes from './routes/instruction'
import MonitorRoutes from '@/routes/monitor'
import notification from './routes/notification'
// import PaymentPeriodPage from '@/pages/payment/period.vue'
import FrontPage from './pages/front'
import DistributionRoutes from '@/routes/distribution'
import PrettyRouters from './routes/pretty'

var routes = [
	{
		path: '/login',
		component: LoginPage,
		meta: {guestOnly: true, layout: 'column1'}
	},
	{
		path: '/logout',
		component: Logout
	},
	// EventRoutes.routes,
	{
		path: '/',
		component: Dashboard,
		meta: {title: 'Главная', breadcrumb: 'Главная'},
		children: [
			{
				path: '/index',
				alias: '',
				component: FrontPage,
				meta: {title: 'Главная'}
			},
			UserRoutes.routes,
			ProductRoutes.routes,
			OnlineRoutes.routes,
			EventRoutes.routes,
			PaymentRoutes.routes,
			MailingRoutes.routes,
			InstructionRoutes.routes,
			MonitorRoutes.routes,
			order.routes,
			notification.routes,
			DistributionRoutes.routes,
			PrettyRouters.routes
		]
	},
	{
		path: '/my',
		component: My
	},
	{
		path: '/live',
		component: Live
	},
	{
		path: '/live-custom',
		component: LiveCustom
	}
]
export default routes



// WEBPACK FOOTER //
// ./src/routes.js